import { MouseEventHandler } from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { IMAGES_REPO } from '../../../../static-resources';

interface ScenarioPlannerEditResetButtonComponentProps {
  disabled?: boolean;
  busy?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onResetElastClick?: MouseEventHandler<HTMLButtonElement>;
  onResetStartingMetricsClick?: MouseEventHandler<HTMLButtonElement>;
  onResetAllClick?: MouseEventHandler<HTMLButtonElement>;
  label: string;
  busyLabel: string;
}
export const ScenarioPlannerEditResetButtonComponent = ({
  disabled,
  busy,
  onClick,
  onResetElastClick,
  onResetStartingMetricsClick,
  onResetAllClick,
  label,
  busyLabel,
}: ScenarioPlannerEditResetButtonComponentProps) => {
  return (
    <Dropdown as={ButtonGroup} disabled={disabled}>
      <Button
        variant="outline-secondary"
        className="btn-common"
        onClick={onClick}
        disabled={disabled}
      >
        <img src={IMAGES_REPO.ResetIcon} alt="Reset" />
        {busy ? busyLabel : label}
      </Button>

      <Dropdown.Toggle
        split
        variant="outline-secondary"
        className="btn-common"
        id="dropdown-split-basic"
        disabled={disabled}
      />

      <Dropdown.Menu>
        <Dropdown.Item disabled={disabled} onClick={onResetElastClick}>
          Reset Elasticities
        </Dropdown.Item>
        <Dropdown.Item
          disabled={disabled}
          onClick={onResetStartingMetricsClick}
        >
          Reset Base Metrics
        </Dropdown.Item>
        <Dropdown.Item disabled={disabled} onClick={onResetAllClick}>
          Reset All
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
